/* FASHKLO v3.1 interactions — header, menus, search, page transitions, reveals, FAQs,
   counters, lightbox, toasts, back-to-top and reading progress.
   Motion follows the "Animations" setting (html[data-motion]) and the viewer's reduced-motion choice. */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = document.documentElement, body = document.body;
  var FK = window.FK || { values: {} };
  var UT = function (k) { return (FK.values && FK.values["ui." + k]) || ""; };
  var esc = function (t) { return String(t == null ? "" : t).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var motion = function () { return reduced ? "off" : (root.getAttribute("data-motion") || "full"); };
  var editing = function () { return body.classList.contains("is-editing"); };
  var current = function () { return $("main > section[data-page]:not([hidden])"); };

  /* ---------- Toasts ---------- */
  var toastBox = document.createElement("div"); toastBox.className = "toasts"; toastBox.setAttribute("aria-live", "polite"); body.appendChild(toastBox);
  window.FKtoast = function (msg, kind) {
    if (!msg) return;
    var t = document.createElement("div"); t.className = "toast" + (kind ? " toast--" + kind : ""); t.textContent = msg;
    toastBox.appendChild(t); requestAnimationFrame(function () { t.classList.add("is-in"); });
    setTimeout(function () { t.classList.remove("is-in"); setTimeout(function () { t.remove(); }, 300); }, 2600);
  };

  /* ---------- Header: shadow on scroll, hides while scrolling down ---------- */
  var hdr = $(".hdr"), lastY = window.scrollY, mega = $(".nav details"), drawer = $("#drawer"), menuBtn = $(".menu-btn");
  function onScroll() {
    var y = window.scrollY, d = y - lastY;
    if (hdr) {
      hdr.classList.toggle("is-scrolled", y > 8);
      var busy = (mega && mega.open) || body.classList.contains("drawer-open") || editing() || motion() === "off";
      if (!busy && d > 6 && y > 420) hdr.classList.add("is-hidden");
      else if (d < -6 || y < 200 || busy) hdr.classList.remove("is-hidden");
    }
    if (topBtn) topBtn.classList.toggle("is-on", y > window.innerHeight * 1.4);
    if (bar && !bar.hidden) { var art = $("article", current()); if (art) { var r = art.getBoundingClientRect(), total = r.height - window.innerHeight * 0.6; bar.firstChild.style.transform = "scaleX(" + Math.max(0, Math.min(1, -r.top / Math.max(1, total))) + ")"; } }
    lastY = y;
  }
  var ticking = false;
  window.addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { onScroll(); ticking = false; }); } }, { passive: true });

  /* ---------- Mega menu: opens on hover with a short intent delay ---------- */
  if (mega) {
    var fine = window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches, tOpen, tClose;
    if (fine) {
      mega.addEventListener("mouseenter", function () { if (editing()) return; clearTimeout(tClose); tOpen = setTimeout(function () { mega.open = true; }, 90); });
      mega.addEventListener("mouseleave", function () { clearTimeout(tOpen); tClose = setTimeout(function () { mega.open = false; }, 220); });
    }
    document.addEventListener("click", function (e) { if (mega.open && !mega.contains(e.target)) mega.open = false; });
  }

  /* ---------- Mobile menu: slide-over panel ---------- */
  function setDrawer(open) {
    if (!drawer) return;
    if (open) { drawer.hidden = false; requestAnimationFrame(function () { drawer.classList.add("is-open"); }); }
    else { drawer.classList.remove("is-open"); setTimeout(function () { if (!drawer.classList.contains("is-open")) drawer.hidden = true; }, motion() === "off" ? 0 : 320); }
    body.classList.toggle("drawer-open", open);
    if (menuBtn) menuBtn.setAttribute("aria-expanded", String(open));
    if (open) { var c = $("[data-drawer-close]", drawer); if (c) setTimeout(function () { c.focus(); }, 60); }
  }
  if (menuBtn) menuBtn.addEventListener("click", function () { setDrawer(true); });
  if (drawer) drawer.addEventListener("click", function (e) {
    if (e.target === drawer || e.target.closest("[data-drawer-close]") || (!editing() && e.target.closest("a"))) setDrawer(false);
  });
  function closeAll() { if (mega) mega.open = false; if (drawer && !drawer.hidden) setDrawer(false); }
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeAll(); closeSearch(); closeLightbox(); } });

  /* ---------- Page transitions and reveals ---------- */
  var io = "IntersectionObserver" in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); countUp(en.target); } });
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 }) : null;
  var RV = ".section .head, .card, .pcard, .tile, .steps > li, .timeline > li, .quote, .panel, .faq > details, .gallery > figure, .split > img, .split > .stack-lg, .prices > *, .grid > .card, .measure > *, .stats > *, .count > *, .case, .tablewrap, .cta-final";
  function prepare(sec, first) {
    if (!sec) return;
    $$(".rv", sec).forEach(function (el) { el.classList.remove("rv", "in"); });
    if (motion() === "off" || editing() || !io) { $$(".measure b, .stats b, .facts b, .case__nums b", sec).forEach(countUp); return; }
    var fold = window.innerHeight;
    $$(RV, sec).forEach(function (el, i) {
      if (el.closest("[data-studio],[data-estimator],.summary")) return;
      var r = el.getBoundingClientRect();
      if (first && r.top < fold) return; // the first frame is always complete
      el.classList.add("rv"); el.style.setProperty("--rv-d", (i % 4) * 60 + "ms"); io.observe(el);
    });
    $$(".measure, .stats, .facts, .case__nums", sec).forEach(function (el) { if (!el.classList.contains("rv")) io.observe(el); });
  }
  var firstRoute = true;
  document.addEventListener("fk:route", function (e) {
    closeAll(); closeSearch(); closeLightbox();
    var sec = current(); if (!sec) return;
    if (!firstRoute && motion() !== "off" && !editing()) { sec.classList.remove("pg-in"); void sec.offsetWidth; sec.classList.add("pg-in"); }
    if (hdr) hdr.classList.remove("is-hidden");
    setTimeout(function () { prepare(sec, firstRoute); firstRoute = false; }, 20);
    if (!firstRoute) { var h = $("h1", sec); if (h && !(e.detail && e.detail.anchor)) { h.setAttribute("tabindex", "-1"); h.focus({ preventScroll: true }); } }
    progress(sec);
  });
  document.addEventListener("fk:editing", function () { $$(".rv").forEach(function (el) { el.classList.add("in"); }); });

  /* ---------- Count-up for figures ---------- */
  function countUp(el) {
    var targets = el.matches && el.matches(".measure b, .stats b, .facts b, .case__nums b, .count b") ? [el] : $$(".measure b, .stats b, .facts b, .case__nums b", el);
    targets.forEach(function (b) {
      if (b._counted || b.hasAttribute("data-days-to") || motion() === "off" || editing()) return;
      var w = document.createTreeWalker(b, NodeFilter.SHOW_TEXT), n, node = null;
      while ((n = w.nextNode())) if (/\d/.test(n.nodeValue)) { node = n; break; }
      if (!node) return;
      var m = node.nodeValue.match(/^(\D*)(\d[\d,]*)(.*)$/); if (!m) return;
      var to = parseInt(m[2].replace(/,/g, ""), 10); if (!(to > 1 && to < 1e6)) return;
      b._counted = true;
      var final = node.nodeValue, t0 = performance.now(), dur = motion() === "subtle" ? 500 : 900, comma = m[2].indexOf(",") >= 0;
      (function step(t) {
        if (node.nodeValue.indexOf(m[1]) !== 0 && node.nodeValue !== final) return;
        var k = Math.min(1, (t - t0) / dur), v = Math.round(to * (1 - Math.pow(1 - k, 3)));
        node.nodeValue = k < 1 ? m[1] + (comma ? v.toLocaleString("en-NG") : v) + m[3] : final;
        if (k < 1) requestAnimationFrame(step);
      })(t0);
    });
  }

  /* ---------- FAQ: smooth open and close ---------- */
  document.addEventListener("click", function (e) {
    var s = e.target.closest && e.target.closest(".faq summary"); if (!s || editing() || motion() === "off") return;
    var d = s.parentElement, ans = $(".ans", d); if (!ans || !ans.animate) return;
    e.preventDefault();
    if (d.open) {
      var h = ans.offsetHeight;
      var a = ans.animate([{ height: h + "px", opacity: 1 }, { height: "0px", opacity: 0 }], { duration: 220, easing: "ease-in" });
      d.classList.add("is-closing"); a.onfinish = function () { d.open = false; d.classList.remove("is-closing"); };
    } else {
      d.open = true; var h2 = ans.offsetHeight;
      ans.animate([{ height: "0px", opacity: 0 }, { height: h2 + "px", opacity: 1 }], { duration: 280, easing: "cubic-bezier(.2,.7,.2,1)" });
    }
  });

  /* ---------- Quick search ---------- */
  var sBox = null, sIdx = null, sSel = 0;
  function buildIndex() {
    var out = [];
    $$("main > section[data-page]").forEach(function (sec) {
      var slug = sec.getAttribute("data-page"); if (slug === "settings" || slug === "enquiries") return;
      var h1 = $("h1", sec), title = h1 ? h1.textContent.trim() : slug, ey = $(".eyebrow", sec);
      out.push({ kind: "Page", title: title, sub: ey ? ey.textContent.trim() : "", href: "#p-" + slug, w: 3 });
      $$("h2", sec).forEach(function (h) {
        var holder = h.closest("[id]"), id = holder && holder.id.indexOf(slug + "--") === 0 ? holder.id.slice(slug.length + 2) : "";
        out.push({ kind: "Section", title: h.textContent.trim(), sub: title, href: "#p-" + slug + (id ? "~" + id : ""), w: 2 });
      });
      $$(".faq summary", sec).forEach(function (q) { out.push({ kind: "Question", title: q.textContent.trim(), sub: title, href: "#p-" + slug + "~faq", w: 1 }); });
    });
    return out;
  }
  function openSearch() {
    if (editing()) return;
    closeAll(); sIdx = buildIndex();
    if (!sBox) {
      sBox = document.createElement("div"); sBox.className = "search"; sBox.setAttribute("role", "dialog"); sBox.setAttribute("aria-label", "Search");
      sBox.innerHTML = '<div class="search__card"><div class="search__bar"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="6.5" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="m16 16 4.5 4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg><input id="fk-search-in" type="search" autocomplete="off" spellcheck="false"><kbd>Esc</kbd></div><ul class="search__list" role="listbox"></ul></div>';
      body.appendChild(sBox);
      sBox.addEventListener("click", function (e) { if (e.target === sBox) closeSearch(); var li = e.target.closest("[data-href]"); if (li) go(li.getAttribute("data-href")); });
      var inp = $("input", sBox);
      inp.addEventListener("input", function () { sSel = 0; drawSearch(); });
      inp.addEventListener("keydown", function (e) {
        var items = $$("[data-href]", sBox);
        if (e.key === "ArrowDown") { e.preventDefault(); sSel = Math.min(items.length - 1, sSel + 1); mark(); }
        if (e.key === "ArrowUp") { e.preventDefault(); sSel = Math.max(0, sSel - 1); mark(); }
        if (e.key === "Enter" && items[sSel]) go(items[sSel].getAttribute("data-href"));
      });
    }
    var inp2 = $("input", sBox); inp2.placeholder = UT("search_placeholder"); inp2.value = "";
    sBox.hidden = false; body.classList.add("search-open"); inp2.focus(); requestAnimationFrame(function () { sBox.classList.add("is-open"); });
    drawSearch();
  }
  function mark() { $$("[data-href]", sBox).forEach(function (li, i) { li.classList.toggle("is-sel", i === sSel); if (i === sSel) li.scrollIntoView({ block: "nearest" }); }); }
  function drawSearch() {
    var q = $("input", sBox).value.trim().toLowerCase(), terms = q.split(/\s+/).filter(Boolean), list = $(".search__list", sBox);
    var res = (terms.length ? sIdx.filter(function (r) { var hay = (r.title + " " + r.sub).toLowerCase(); return terms.every(function (t) { return hay.indexOf(t) >= 0; }); }) : sIdx.filter(function (r) { return r.kind === "Page"; }))
      .map(function (r) { var s = r.w * 10 + (terms.length && r.title.toLowerCase().indexOf(terms[0]) === 0 ? 5 : 0); return { r: r, s: s }; })
      .sort(function (a, b) { return b.s - a.s; }).slice(0, 12);
    list.innerHTML = res.length ? res.map(function (x, i) { return '<li role="option" data-href="' + x.r.href + '"' + (i === sSel ? ' class="is-sel"' : "") + '><span class="search__kind">' + x.r.kind + "</span><b>" + esc(x.r.title) + "</b>" + (x.r.sub && x.r.sub !== x.r.title ? "<small>" + esc(x.r.sub) + "</small>" : "") + "</li>"; }).join("") : '<li class="search__empty">' + esc(UT("search_empty")) + "</li>";
  }
  function go(href) { closeSearch(); if (location.hash === href) window.dispatchEvent(new HashChangeEvent("hashchange")); else location.hash = href; }
  function closeSearch() { if (!sBox || sBox.hidden) return; sBox.classList.remove("is-open"); body.classList.remove("search-open"); setTimeout(function () { sBox.hidden = true; }, 180); }
  document.addEventListener("click", function (e) { var b = e.target.closest && e.target.closest("[data-search-open]"); if (b && !editing()) { e.preventDefault(); openSearch(); } });
  document.addEventListener("keydown", function (e) {
    var t = e.target, typing = t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName));
    if (((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") || (e.key === "/" && !typing)) { e.preventDefault(); openSearch(); }
  });

  /* ---------- Lightbox for photos ---------- */
  var LB = ".gallery img, .split > img, .collage img, .article img, .phero__media img, .case img, .bento img, .ac-wide img, .ac-split__img img, .fabcard img";
  var lb = null, lbList = [], lbI = 0;
  function openLightbox(img) {
    var grp = img.closest(".fabcards"); lbList = (grp ? $$(".fabcard:not([hidden]) img", grp) : $$(LB, current())).filter(function (i) { return !i.closest("a"); }); lbI = Math.max(0, lbList.indexOf(img));
    if (!lb) {
      lb = document.createElement("div"); lb.className = "lightbox"; lb.setAttribute("role", "dialog"); lb.setAttribute("aria-label", "Photo");
      lb.innerHTML = '<figure><img alt=""><figcaption></figcaption></figure><button type="button" class="lb-btn lb-prev" aria-label="Previous photo">‹</button><button type="button" class="lb-btn lb-next" aria-label="Next photo">›</button><button type="button" class="lb-btn lb-x" aria-label="Close">×</button>';
      body.appendChild(lb);
      lb.addEventListener("click", function (e) {
        if (e.target.closest(".lb-prev")) return show(-1); if (e.target.closest(".lb-next")) return show(1);
        if (e.target.closest(".lb-x") || e.target === lb || e.target.tagName === "FIGURE") closeLightbox();
      });
      document.addEventListener("keydown", function (e) { if (!lb || lb.hidden) return; if (e.key === "ArrowRight") show(1); if (e.key === "ArrowLeft") show(-1); });
    }
    show(0); lb.hidden = false; body.classList.add("search-open"); requestAnimationFrame(function () { lb.classList.add("is-open"); });
  }
  function show(d) {
    lbI = (lbI + d + lbList.length) % lbList.length; var src = lbList[lbI]; if (!src) return;
    var im = $("img", lb), fig = src.closest("figure"), cap = fig && $("figcaption", fig);
    var full = src.getAttribute("data-full"), fc = src.closest(".fabcard");
    /* Fabric cards open the full sheet (drape, print detail, reverse) unless the swatch photo was replaced in the editor. */
    im.src = full && /-sw\.jpg$/.test(src.getAttribute("src") || "") ? full : (src.currentSrc || src.src); im.alt = src.alt;
    $("figcaption", lb).textContent = fc ? ($("[data-out='fname']", fc).textContent + " · " + ($(".fabcard__feel", fc) || {}).textContent) : cap ? cap.textContent : src.alt;
    $$(".lb-prev,.lb-next", lb).forEach(function (b) { b.hidden = lbList.length < 2; });
  }
  function closeLightbox() { if (!lb || lb.hidden) return; lb.classList.remove("is-open"); body.classList.remove("search-open"); setTimeout(function () { lb.hidden = true; }, 200); }
  document.addEventListener("click", function (e) {
    var zb = e.target.closest && e.target.closest("[data-fabzoom]");
    if (zb && !editing()) { var zi = $("img", zb.closest(".fabcard")); if (zi) { e.preventDefault(); openLightbox(zi); return; } }
    var img = e.target.closest && e.target.closest(LB);
    if (!img || editing() || img.closest("a") || !img.closest("main")) return;
    openLightbox(img);
  });

  /* ---------- Back to top and reading progress ---------- */
  var topBtn = document.createElement("button"); topBtn.type = "button"; topBtn.className = "totop"; topBtn.setAttribute("aria-label", "Back to top");
  topBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19V5m0 0-6 6m6-6 6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  topBtn.addEventListener("click", function () { window.scrollTo({ top: 0, behavior: motion() === "off" ? "auto" : "smooth" }); });
  body.appendChild(topBtn);
  var bar = document.createElement("div"); bar.className = "progress"; bar.hidden = true; bar.innerHTML = "<span></span>"; body.appendChild(bar);
  function progress(sec) { bar.hidden = !$("article", sec); onScroll(); }
  document.addEventListener("fk:settings", function () { topBtn.title = UT("top"); topBtn.setAttribute("aria-label", UT("top") || "Back to top"); });

  /* ---------- Product rails: arrows and progress bar ---------- */
  function railSync(r) {
    var bar = r.parentElement.querySelector(".ac-progress span"); if (!bar) return;
    var max = r.scrollWidth - r.clientWidth, vis = r.clientWidth / Math.max(1, r.scrollWidth);
    bar.style.width = Math.max(12, vis * 100) + "%";
    bar.style.transform = "translateX(" + (max > 0 ? (r.scrollLeft / max) * ((1 / Math.max(vis, .01)) - 1) * 100 : 0) + "%)";
  }
  $$("[data-rail]").forEach(function (r) { r.addEventListener("scroll", function () { railSync(r); }, { passive: true }); railSync(r); });
  window.addEventListener("resize", function () { $$("[data-rail]").forEach(railSync); });
  document.addEventListener("fk:route", function () { setTimeout(function () { $$("[data-rail]").forEach(railSync); }, 60); });
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-rail-prev],[data-rail-next]"); if (!b || editing()) return;
    var r = b.closest("section").querySelector("[data-rail]"); if (!r) return;
    var step = (r.firstElementChild ? r.firstElementChild.getBoundingClientRect().width + 16 : r.clientWidth * .8) * (window.innerWidth > 1000 ? 2 : 1);
    r.scrollBy({ left: b.hasAttribute("data-rail-next") ? step : -step, behavior: motion() === "off" ? "auto" : "smooth" });
  });

  /* ---------- Filter chips (catalogue pages) ---------- */
  document.addEventListener("click", function (e) {
    var c = e.target.closest && e.target.closest("[data-filter-group] [data-filter]"); if (!c || editing()) return;
    var g = c.closest("[data-filter-group]"), name = g.getAttribute("data-filter-group"), f = c.getAttribute("data-filter");
    $$("[data-filter]", g).forEach(function (x) { var on = x === c; x.classList.toggle("is-on", on); x.setAttribute("aria-pressed", String(on)); });
    $$('[data-filter-list="' + name + '"] [data-cat]').forEach(function (it) { it.classList.toggle("ac-filtered", f !== "all" && it.getAttribute("data-cat") !== f); });
  });

  onScroll();
})();
